import Lenis from '@studio-freight/lenis';
import { useEffect } from 'react';

export default function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 2.2, // speed
      easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easing function
      // smooth: true ❌ (remove this line)
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);
}
